import { render, staticRenderFns } from "./wizard-steps.vue?vue&type=template&id=5a4fe60c&scoped=true"
import script from "./wizard-steps.vue?vue&type=script&lang=js"
export * from "./wizard-steps.vue?vue&type=script&lang=js"
import style0 from "./wizard-steps.vue?vue&type=style&index=0&id=5a4fe60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4fe60c",
  null
  
)

export default component.exports